import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { WorkspacePersona } from '../models/personas';

export const WorkspacePersonaFetch = createAction('[WorkspacePersona] Fetch', props<{ workspaceId: string }>());
export const WorkspacePersonaFetched = createAction(
  '[WorkspacePersona] Fetched',
  props<{ workspaceId: string; workspacePersonas: WorkspacePersona[] }>()
);
export const WorkspacePersonaError = createAction('[WorkspacePersona] Error', props<{ workspaceId: string }>());

export const initialState: Record<string, CommonApiState<WorkspacePersona[]>> = {};

export const workspacePersonaFeature = createFeature({
  name: 'workspacePersona',
  reducer: createReducer(
    initialState,
    on(WorkspacePersonaFetch, (state, action) => ({
      ...state,
      [action.workspaceId]: {
        ...(state[action.workspaceId] ?? {}),
        currentPedingApis: (state[action.workspaceId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(WorkspacePersonaFetched, (state, action) => {
      return {
        ...state,
        [action.workspaceId]: {
          ...(state[action.workspaceId] ?? {}),
          currentPedingApis: 0,
          data: action.workspacePersonas
        }
      };
    }),
    on(WorkspacePersonaError, (state, action) => {
      return {
        ...state,
        [action.workspaceId]: {
          ...(state[action.workspaceId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectWorkspacePersonaState }) => {
    const workspacePersonaIsLoading = (workspaceId: string) =>
      createSelector(
        selectWorkspacePersonaState,
        workspacePersonasState => (workspacePersonasState[workspaceId]?.currentPedingApis ?? 0) > 0
      );

    const workspacePersonaHasPendingRequest = (workspaceId: string) =>
      createSelector(
        selectWorkspacePersonaState,
        workspacePersonasState => (workspacePersonasState[workspaceId]?.currentPedingApis ?? 0) >= 2
      );
    const workspacePersonaData = (workspaceId: string) => {
      return createSelector(selectWorkspacePersonaState, workspacePersonaState => {
        return workspacePersonaState[workspaceId]?.data;
      });
    };
    const workspacePersonaIsError = (workspaceId: string) => {
      return createSelector(selectWorkspacePersonaState, workspacePersonaState => {
        return workspacePersonaState[workspaceId]?.isError;
      });
    };

    return {
      workspacePersonaIsLoading,
      workspacePersonaIsError,
      workspacePersonaHasPendingRequest,
      workspacePersonaData
    };
  }
});
